import { styled } from "@mui/material";

export const StyledLoginForm = styled("form")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "25rem",
  gap: ".5rem",
  padding: "5rem 2rem",
  marginRight: "5rem",
  background: theme.color.background,
  borderRadius: "5px",
  h4: {
    padding: "0",
    fontWeight: "bold",
    color: theme.color.dark,
    b: {
      color: theme.color.main,
    },
  },
  p: {
    color: theme.palette.error.main,
    fontFamily: "'Product Sans', sans-serif",
    fontWeight: "bold",
    position: "absolute",
    padding: ".5rem",
    right: "0",
  },
  button: {
    width: "100%",
  },
  [`@media screen and (max-width: ${theme.breakpoints.values.mobile}px)`]: {
    padding: "2rem",
    width: "75%",
    margin: "0"
  },
}));
